import React from 'react'
import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { useFinstrongStore, useGlobalCopyStore } from '../../common'
import { KeyIndicatorsTabItemType } from '../constants'
import { getSpendingFeeCountStatus, getSpendToIncomeRatioState } from '../util/finstrongUtils'

import KeyIndicatorsTabsItem from './KeyIndicatorsTabItem'
import { buildDynamicCopy } from '../../core/utils/Localization'

const KeyIndicatorsSpendTab: React.FC = () => {
  const { finstrong: copyContent } = useGlobalCopyStore()
  const { key_indicators_spend: spendCopy } = copyContent
  const { healthScore } = useFinstrongStore()

  const getSpendToIncomeRatioStatus = (ratio: number | null) => {
    const state = getSpendToIncomeRatioState(ratio)

    const cardStatusMapping = {
      GOOD: spendCopy.ratio_good_description,
      FAIR: spendCopy.ratio_fair_description,
      OFF_TRACK: spendCopy.ratio_off_track_description,
      MISSING: spendCopy.ratio_missing_description,
    }

    const description =
      state === 'MISSING'
        ? cardStatusMapping[state]
        : (buildDynamicCopy(cardStatusMapping[state], ratio) as string)

    return {
      cardState: state,
      description,
      title: spendCopy.ratio_card_title,
    }
  }

  const { spendToIncomeRatio, spendFeeCount } = React.useMemo(() => {
    const healthScoreRatio =
      healthScore.spend_to_income_ratio !== null
        ? Math.round(healthScore.spend_to_income_ratio * 100)
        : null
    const spendToIncomeRatio = getSpendToIncomeRatioStatus(healthScoreRatio)
    const spendFeeCount = getSpendingFeeCountStatus(
      healthScore.spending_fee_transaction_count,
      spendCopy,
    )

    return { spendToIncomeRatio, spendFeeCount }
  }, [
    healthScore.spend_to_income_ratio,
    healthScore.spending_fee_transaction_count,
    spendCopy,
    copyContent,
  ])

  return (
    <Stack sx={{ gap: 24, p: 8, pt: 24 }}>
      <KeyIndicatorsTabsItem
        cardState={spendToIncomeRatio.cardState}
        description={spendToIncomeRatio.description}
        drawerFor={KeyIndicatorsTabItemType.SpendLessThanYouMake}
        title={spendToIncomeRatio.title}
      />
      <KeyIndicatorsTabsItem
        cardState={spendFeeCount.cardState}
        description={spendFeeCount.description}
        drawerFor={KeyIndicatorsTabItemType.PayBillsOnTime}
        title={spendFeeCount.title}
      />
    </Stack>
  )
}

export default observer(KeyIndicatorsSpendTab)
